import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { registerLicense } from '@syncfusion/ej2-base';
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import Reducer from './utils/Reducer';


const store = createStore(Reducer);
registerLicense('Mgo+DSMBaFt/QHJqVVhjWlpFdEBBXHxAd1p/VWJYdVt5flBPcDwsT3RfQF9jQHxXdkZnW3xXcnVWTw==;Mgo+DSMBPh8sVXJ0S0R+XE9HcFRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3xTf0dnWXxacndcRGNeWA==;ORg4AjUWIQA/Gnt2VVhiQlFadVlJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkxhXX9ddHZWT2JYV00=;NzIyMzA1QDMyMzAyZTMyMmUzMFZ4eHByS01uRVl1MDljRmxYZVMwbVZLUkJvVUVJbVlRTjV5OXZQMGMzZ0k9;NzIyMzA2QDMyMzAyZTMyMmUzMFlKMk1sUzBjWDBJQ0pVN083TnZPZnJacWVlcE5lczdoVVBwME5NemtGaFk9;NRAiBiAaIQQuGjN/V0Z+Xk9EaFxEVmJLYVB3WmpQdldgdVRMZVVbQX9PIiBoS35RdEVqW3tec3BXRWlfUEZ/;NzIyMzA4QDMyMzAyZTMyMmUzMEpBVmpCYXlKdDB5Zm4wa0ZBd0pDRk42dS90UjdMNktPbVdObDdEV0I2VUU9;NzIyMzA5QDMyMzAyZTMyMmUzMElIY0V4MUZMNU9Say9lRGJ1dW81MW00clVHa1JaYVZ0dFQvMlRGS21xZ0U9;Mgo+DSMBMAY9C3t2VVhiQlFadVlJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkxhXX9ddHZWT2NUVU0=;NzIyMzExQDMyMzAyZTMyMmUzMGMzK3l3WERZQStDRWd5cHgvbTJybUJzbTJneEVOeVJDWjc0LytWVE8rWlk9;NzIyMzEyQDMyMzAyZTMyMmUzMGFDSTA0OXJQeTJxQmV5aVFUb2lQTFprL1FhZWh6VWk5UFVyMms3YmhEL2s9;NzIyMzEzQDMyMzAyZTMyMmUzMEpBVmpCYXlKdDB5Zm4wa0ZBd0pDRk42dS90UjdMNktPbVdObDdEV0I2VUU9');

ReactDOM.render(
  
        <Provider store ={store}>
    <App />
    </Provider>
        
        
    ,
  

  document.getElementById('root')
);



